module.exports = __webpack_public_path__ + "img/reports.0941d0ac.png";